import React, { useState, useEffect, useMemo } from "react";
import moment from "moment";
import TableContainer from "./TableContainer";
import PatientLoader from "../../../common/PatientLoader";
import "./HomeDataTableStyles.css";
import RiskPill from "../../../common/RiskPill";
import { useNavigate } from "react-router-dom";
import { getHealthcareGroupData } from "../../../../store/features/ops/opsSlice";

const HomeDataTable = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    getHealthcareGroupData()
      .then((res) => {
        setData(Object.values(res?.data?.data));
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  }, []);

  let renderColumns = [
    {
      Header: "Name",
      accessor: "name",
      Cell: ({ cell }) => {
        return (
          <span style={{ textTransform: "capitalize" }}>{cell.value}</span>
        );
      },
    },
    {
      Header: "Type",
      accessor: "type",
      Cell: ({ cell }) => {
        return (
          <RiskPill
            icon_type="user"
            styles={{ width: "100%", gap: "5px" }}
            type={cell?.value?.toLowerCase() || "not specified"}
            show_icon={true}
          />
        );
      },
    },
    {
      Header: "Created",
      accessor: "created",
      sortType: (a, b) => {
        if (a === null || a === undefined || a === "" || a === "Not Available")
          return 1; // place null values at the bottom
        if (b === null || b === undefined || b === "" || b === "Not Available")
          return -1;
        return new Date(b?.values?.created) - new Date(a?.values?.created);
      },

      Cell: ({ cell }) => {
        return (
          <span style={{ textTransform: "capitalize" }}>
            {cell.value
              ? moment(cell.value).format("MMM Do, YYYY")
              : "Not Available"}
          </span>
        );
      },
    },
    {
      Header: "Locations",
      accessor: "locations",
      disableSortBy: true,
      Cell: ({ cell }) => {
        return <span>{cell.value}</span>;
      },
    },
    {
      Header: "Sales Representative",
      accessor: "sales_rep",
      Cell: ({ cell }) => {
        return (
          <span style={{ textTransform: "capitalize" }}>
            {cell.value || "Not Specified"}
          </span>
        );
      },
    },
    {
      Header: "Invoices Pending Action",
      accessor: "pending_invoice_actions",
      disableSortBy: true,
      Cell: ({ cell }) => {
        return (
          <span style={{ color: cell.value > 0 ? "red" : "green" }}>
            {cell.value}
          </span>
        );
      },
    },
    {
      Header: "Actions",
      accessor: "clinic_id",
      disableSortBy: true,
      Cell: ({ cell }) => {
        return (
          <button
            onClick={() => navigate(`/ops/clinic/${cell.value}`)}
            className="primary-btn-small"
          >
            View
          </button>
        );
      },
    },
  ];

  const columns = useMemo(() => renderColumns, [data, loading]);

  return (
    <>
      {loading ? (
        <PatientLoader />
      ) : (
        <TableContainer columns={columns} data={data} />
      )}
    </>
  );
};

export default HomeDataTable;
